import React, { FC } from 'react'
import { FooterColumn } from '@chegg-wt/core/types/core'
import * as Styled from './styled'

interface FooterColumnsProps {
  columns: FooterColumn[]
  ccpa: boolean
}

export const FooterColumns: FC<FooterColumnsProps> = ({ columns, ccpa }) => {
  const getFooterLinks = ({ links }) => {
    if (!ccpa) {
      const footerLinks = links.filter((link) => link.id !== 'ot-sdk-btn')
      return footerLinks
    }
    return links
  }

  return (
    <>
      {columns.map((column) => (
        <Styled.Column key={column.title}>
          <Styled.LinkListHeader>{column.title}</Styled.LinkListHeader>
          <Styled.LinkList>
            {getFooterLinks({ links: column.links }).map((link) => (
              <Styled.FooterListItem key={link.url + link.name}>
                <Styled.Link
                  id={link.id}
                  className={link.className}
                  href={link.url}
                  rel={link.rel || null}
                  darkGray
                >
                  {link.name}
                </Styled.Link>
              </Styled.FooterListItem>
            ))}
          </Styled.LinkList>
        </Styled.Column>
      ))}
    </>
  )
}
